import { api } from '@/lib/api'
import type { AssistantHandoffRequest } from '@tenfour/contracts'

export interface PortalNotification {
  id: string
  accountId: string
  eventType: string
  title: string
  body: string
  read: boolean
  entityType: string | null
  entityId: string | null
  createdAt: string
  handoff?: AssistantHandoffRequest
}

export async function listNotifications(
  accountId: string,
  opts?: { unreadOnly?: boolean; limit?: number },
): Promise<PortalNotification[]> {
  const params = new URLSearchParams({ accountId })
  if (opts?.unreadOnly) params.set('unreadOnly', 'true')
  if (opts?.limit) params.set('limit', String(opts.limit))
  return api<PortalNotification[]>(`/notifications?${params}`)
}

export async function getUnreadCount(accountId: string): Promise<number> {
  const res = await api<{ count: number }>(`/notifications/unread-count?accountId=${accountId}`)
  return res.count
}

export async function markNotificationRead(id: string, accountId: string): Promise<void> {
  await api(`/notifications/${id}/read?accountId=${accountId}`, { method: 'POST' })
}

export async function markAllNotificationsRead(accountId: string): Promise<void> {
  await api(`/notifications/read-all?accountId=${accountId}`, { method: 'POST' })
}

export async function deleteNotification(id: string, accountId: string): Promise<void> {
  await api(`/notifications/${id}?accountId=${accountId}`, { method: 'DELETE' })
}

export async function deleteAllNotifications(accountId: string): Promise<void> {
  await api(`/notifications?accountId=${accountId}`, { method: 'DELETE' })
}
